import { PaymentElement } from '@stripe/react-stripe-js';
import React from 'react';

// Used for old Stripe elment. Keeping in case we need in future.
const useOptions = () => {
  const options = React.useMemo(
    () => ({
      style: {
        base: {
          fontSize: '16px',
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [],
  );

  return options;
};

const StripePaymentElement = () => (
  <PaymentElement />
);

export default StripePaymentElement;
